// @flow
import type { Element, Node } from 'React';

import React from 'react';
import { Col } from 'reactstrap';
import { COMPONENT_FORM } from '@hbrisk/sp3-risk-model-support/components/form/name.js';
import { EnhancedFormGroupCol } from '#components/support/forms/utility/index.js';

type columnProps =
  | string
  | number
  | boolean
  | {|
      size: string | number | boolean,
      order: string | number,
      offset: string | number,
    |};

type Props = {|
  children?: Node,
  xs?: columnProps | null,
  sm?: columnProps | null,
  md?: columnProps | null,
  lg?: columnProps | null,
  xl?: columnProps | null,
  fields?: Array<string>,
|};

/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
const ComponentFormGroupCol = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  fields,
  ...rest
}: Props): Element<typeof Col> => (
  <EnhancedFormGroupCol
    form={COMPONENT_FORM}
    fields={fields}
    xs={xs}
    sm={sm}
    md={md}
    lg={lg}
    xl={xl}
    {...rest}
  >
    {children}
  </EnhancedFormGroupCol>
);

export default ComponentFormGroupCol;
